import { render, staticRenderFns } from "./Show-aviso.vue?vue&type=template&id=2ef1f826&scoped=true&"
import script from "./Show-aviso.vue?vue&type=script&lang=js&"
export * from "./Show-aviso.vue?vue&type=script&lang=js&"
import style0 from "./Show-aviso.vue?vue&type=style&index=0&id=2ef1f826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1f826",
  null
  
)

export default component.exports